import Swiper, { Lazy, Navigation, EffectFade, Controller } from 'swiper'
import gsap from 'gsap'
import lightGallery from 'lightgallery'
import lgThumbnail from 'lightgallery/plugins/thumbnail'

import 'swiper/css'

Swiper.use([Lazy, Navigation, EffectFade, Controller])

export default function() {
  const ease = 'cubic-bezier(0.33, 0, 0.13, 1)'
  const sections = document.querySelectorAll('.gallery-section')

  sections.forEach(section => {
    const slideCurrentElement = section.querySelector('.gallery-count__current')
    const slideAllElement = section.querySelector('.gallery-count__all')

    new Swiper(section.querySelector('.gallery-slider'), {
      watchSlidesProgress: true,
      fadeEffect: true,

      lazy: {
        loadPrevNext: false,
        loadOnTransitionStart: true,
      },

      navigation: {
        prevEl: section.querySelector('.swiper-button-prev'),
        nextEl: section.querySelector('.swiper-button-next'),
      },

      on: {
        init(swiper) {
          slideCurrentElement.innerHTML = swiper.activeIndex + 1
          slideAllElement.innerHTML = swiper.slides.length

          gsap.to(section.querySelector('.gallery-count-wrapp'), {
            opacity: 1,
            duration: 0.5,
          })
        },
        afterInit() {
          gsap.to(section, {
            opacity: 1,
            y: 0,
            duration: 1,
            delay: 0.5,
          })
        },

        slideChange(swiper) {
          slideCurrentElement.innerHTML = swiper.activeIndex + 1
        },
      },
    })

    lightGallery(section.querySelector('.gallery-slider-wrapper'), {
      selector: section.querySelectorAll('.gallery-slide'),
      licenseKey: '99B5763A-C4064650-BC4A5A7C-FBDF4A63',
      plugins: [lgThumbnail],
      exThumbImage: 'data-external-thumb-image',
      thumbMargin: 16,
      thumbWidth: 130,
      thumbnail: true,
      download: false,
      hideControlOnEnd: true,
      prevHtml:
        '<svg class="w-6" viewBox="0 0 37 14"> <use xlink:href="#arrow-prev"></use> </svg>',
      nextHtml:
        '<svg class="w-6" viewBox="0 0 37 14"> <use xlink:href="#arrow-next"></use> </svg>',
      counter: false,
      easing: ease,
      loop: false,
      preload: 1,
      speed: 200,
      mode: 'lg-fade',
      backdropDuration: 400,
      mobileSettings: {
        controls: true,
        showCloseIcon: true,
        thumbWidth: 80,
        thumbHeight: '64px',
      },
    })
  })
}
